import Vue from "vue";

// vue-notification
import Notifications from "vue-notification";
import velocity from "velocity-animate";
Vue.use(Notifications, { velocity });

function notice(type, options) {
    return Vue.notify({
        group: type,
        title: options.title,
        text: options.desc,
        duration: options.duration || 10000
    });
}

export const Notify = {
    success(options) {
        return notice("success", options);
    },
    error(options) {
        return notice("error", options);
    },
    warning(options) {
        return notice("error", options);
    }
};



// WEBPACK FOOTER //
// ./src/components/Middleware/notification.js